import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const comparisonContent = {
  title: 'Tu práctica clínica antes y después del MegaPack',
  subtitle: 'La diferencia entre improvisar y trabajar con un sistema clínico ordenado.',
  without: {
    title: 'SIN el MegaPack',
    items: ['Buscás material suelto en internet sin respaldo clínico', 'Pasás horas armando fichas y registros desde cero', 'Las sesiones se sienten improvisadas y poco estructuradas', 'No tenés un sistema unificado para evaluar el neurodesarrollo', 'Las familias se van sin material concreto para trabajar en casa', 'Te falta tiempo para investigar y actualizarte']
  },
  with: {
    title: 'CON el MegaPack',
    items: ['Tenés 6 tomos clínicos basados en evidencia, listos para aplicar', 'Imprimís y usás fichas profesionales en minutos', 'Cada sesión sigue una estructura clínica clara y reproducible', 'Contás con un sistema completo de evaluación del neurodesarrollo', 'Entregás material visual de calidad para que las familias acompañen el proceso', 'Ganás horas semanales y elevás el valor percibido de tu servicio']
  }
};
export function Comparison() {
  return <section className="py-24 px-4 bg-brand-dark" data-id="element-59">
      <div className="max-w-6xl mx-auto" data-id="element-60">
        <div className="text-center mb-16" data-id="element-61">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif mb-4 text-brand-light" data-id="element-62">
            {comparisonContent.title}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-light/70 font-sans max-w-2xl mx-auto" data-id="element-63">
            {comparisonContent.subtitle}
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-64">
          {/* SIN el pack */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-brand-card border border-red-900/30 rounded-2xl p-8" data-id="element-65">
            <div className="flex items-center gap-3 mb-8 pb-6 border-b border-brand-cardBorder" data-id="element-66">
              <div className="w-10 h-10 rounded-full bg-red-950/50 flex items-center justify-center" data-id="element-67">
                <X className="w-5 h-5 text-red-400" data-id="element-68" />
              </div>
              <h3 className="text-2xl font-serif text-red-200" data-id="element-69">
                {comparisonContent.without.title}
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-70">
              {comparisonContent.without.items.map((item, index) => <li key={index} className="flex items-start gap-3 text-brand-light/70 font-sans" data-id="element-71">
                  <X className="w-5 h-5 text-red-400/70 shrink-0 mt-0.5" data-id="element-72" />
                  <span data-id="element-73">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* CON el pack */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-brand-card border border-emerald-900/40 rounded-2xl p-8 relative shadow-[0_0_40px_rgba(16,185,129,0.08)]" data-id="element-74">
            <div className="flex items-center gap-3 mb-8 pb-6 border-b border-brand-cardBorder" data-id="element-75">
              <div className="w-10 h-10 rounded-full bg-emerald-950/50 flex items-center justify-center" data-id="element-76">
                <Check className="w-5 h-5 text-emerald-400" data-id="element-77" />
              </div>
              <h3 className="text-2xl font-serif text-emerald-100" data-id="element-78">
                {comparisonContent.with.title}
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-79">
              {comparisonContent.with.items.map((item, index) => <li key={index} className="flex items-start gap-3 text-brand-light/90 font-sans" data-id="element-80">
                  <Check className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-81" />
                  <span data-id="element-82">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}